import { render, staticRenderFns } from "./oEmbed.vue?vue&type=template&id=31206ac0&"
import script from "./oEmbed.vue?vue&type=script&lang=js&"
export * from "./oEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports